import {useCallback, useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Menu from '../menu/Menu';

import './Header.css';

function Header({ activeElement, handleFeedback, handlePath, handleStartOver }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(prevIsMenuOpen => !prevIsMenuOpen);
  }, []);

  const handleFeedbackAndMenu = useCallback(() => {
    toggleMenu();
    handleFeedback();
  }, [handleFeedback, toggleMenu]);

  const handlePlan = useCallback(() => {
    navigate('/plan', { state: { from: location.pathname }});
  }, [location, navigate]);

  const handleProfile = useCallback(() => {
    navigate('/profile', { state: { from: location.pathname }});
  }, [location, navigate]);

  return (
    <div id="header">
      <div className="header-icon menu" title="Menu" onClick={toggleMenu}></div>
      <div className="header-icons">
        <div className={'header-icon header-icon-text path' + (activeElement === 'path' ? ' active' : '')} title="Your Path" onClick={handlePath}>Your Path</div>
        <div className={'header-icon header-icon-text plan' + (activeElement === 'plan' ? ' active' : '')} title="Your Plan" onClick={handlePlan}>Your Plan</div>
        <div className={'header-icon header-icon-text profile' + (activeElement === 'profile' ? ' active' : '')} title="About You" onClick={handleProfile}>About You</div>
      </div>
      <div className="header-icon start-over" title="Start Over" onClick={handleStartOver}>Start Over</div>
      {isMenuOpen ? (
        <Menu handleFeedback={handleFeedbackAndMenu} toggleMenu={toggleMenu} />
      ) : null}
    </div>
  );
}

export default Header;
